import { setGetStatLotteryAction } from '../action';
import { getStatLottery } from '../api/getStatLottery';

const setGetStatLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getStatLottery(params);

            if (data.status === 'success') {
                dispatch(setGetStatLotteryAction({
                    data: data.data,
                    page: data.count,
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetStatLottery
}